<template>
    <div class="card my-5 text-center">
        <img :src="src" class="object-contain mx-auto" @click="onClick(url)" alt />
    </div>
</template>
<script>
export default {
    name: 'BankCard',
    props: {
        src: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        }
    },
    methods: {
        onClick: function (url) {
            this.setTracking(url)
            window.location = this.url
        },
        setTracking: function(url){
            let trackCategory = 'issuer_card';
            let trackAction = 'click_issuer_card';
            let tracking_label = '';
            if(url.toLowerCase().indexOf('aeon') > -1){
                tracking_label = 'bank_name=aeon'
            }else if((url.toLowerCase()).indexOf('kbank') > -1){
                tracking_label = 'bank_name=kbank'
            }else if((url.toLowerCase()).indexOf('kcc') > -1){
                tracking_label = 'bank_name=bay'
            }else if((url.toLowerCase()).indexOf('ktc') > -1){
                tracking_label = 'bank_name=ktb'
            }else if(url.toLowerCase().indexOf('scb') > -1){
                tracking_label = 'bank_name=scb'
            }
            this.tracking.event(trackCategory, trackAction, tracking_label, null);
        },
    }
}
</script>

<style lang="scss" scoped>
.card {
    img {
        // box-shadow: 0 4px 4px 0 #e0efff;
    }
}
</style>
